import React, { useEffect, useState } from 'react'

import { ReactComponent as HeartSVG } from '../../lib/assets/suits/heart.svg'
import { ReactComponent as SpadeSVG } from '../../lib/assets/suits/spades.svg'
import { ReactComponent as ClubSVG } from '../../lib/assets/suits/club.svg'
import { ReactComponent as DiamondSVG } from '../../lib/assets/suits/diamond.svg'
import { colors } from 'lib/colors'

export const useCardCombinations = (coefs: any[]) => {
  const [combArray, setCombArray] = useState<any[]>([])
  useEffect(() => {
    coefs &&
      setCombArray([
        {
          combinationName: 'Royal flush',
          coef: coefs[9],
          cards: [
            {
              name: '10',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'J',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'Q',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'K',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'A',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Straight flush',
          coef: coefs[8],
          cards: [
            {
              name: '10',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: 'J',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '9',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '8',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '7',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Four of a kind',
          coef: coefs[7],
          cards: [
            {
              name: 'Q',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'Q',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'Q',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: 'Q',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '6',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: 'Full house',
          coef: coefs[6],
          cards: [
            {
              name: 'Q',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'Q',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '2',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '2',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '2',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Flush',
          coef: coefs[5],
          cards: [
            {
              name: '2',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '10',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '4',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '7',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'A',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Straight',
          coef: coefs[4],
          cards: [
            {
              name: '2',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '3',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '4',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '5',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '6',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Three of a kind',
          coef: coefs[3],
          cards: [
            {
              name: 'K',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'K',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'K',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '5',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: '9',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
        {
          combinationName: 'Two Pairs',
          coef: coefs[2],
          cards: [
            {
              name: 'Q',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'Q',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '4',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: '2',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: true,
            },
            {
              name: '2',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
          ],
        },
        {
          combinationName: 'Pair Of Aces',
          coef: coefs[1],
          cards: [
            {
              name: 'A',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: 'A',
              suit: <HeartSVG />,
              color: colors.secondaryText,
              win: true,
            },
            {
              name: '4',
              suit: <ClubSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: '1',
              suit: <SpadeSVG />,
              color: colors.secondaryBackground,
              win: false,
            },
            {
              name: 'Q',
              suit: <DiamondSVG />,
              color: colors.secondaryText,
              win: false,
            },
          ],
        },
      ])
  }, [coefs])

  return [combArray]
}
